import { getSessionBlockValidationSchema } from "@/modules/sessions/sessionForm/sessionBlockFormikTypes"
import { requiredInput } from "@modules/form/formUtils"
import * as Yup from "yup"

export type BoxSlotSessionInputKey = "name" | "description" | "blocks"

export function getBoxSessionValidationSchema() {
  return Yup.object({
    name: requiredInput(Yup.string()),
    description: Yup.string(),
    blocks: Yup.array().of(getSessionBlockValidationSchema()),
  })
}
